<template>
  <div>
    <Header :title="title" :showBack="true"></Header>
    <iframe :src="ContractUrl" v-if="ContractUrl!=''" width="100%" height="900px"></iframe>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header
  },
  data() {
    return {
      title: "合同预览", //标题
      ContractUrl: this.$route.query.ContractUrl
    };
  },
  watch: {},
  methods: {},
  mounted: function() {},
  created() {}
};
</script>

